export const GET_TIPS = "store/tips/GET_TIPS";
export const GET_TIPS_COMPLETED = "store/tips/GET_TIPS_COMPLETED";
export const GET_TIPS_FAILED = "store/tips/GET_TIPS_FAILED";
